export default __webpack_public_path__ + "static/media/snow-A1.c6862ea4.png";